var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("AppModal", { attrs: { id: _vm.id, options: _vm.options } }, [
    _c(
      "div",
      { staticClass: "flex items-center" },
      [
        _c("LoadingCircle", { staticClass: "w-8 h-8 text-primary-700 mr-4" }),
        _vm.message
          ? _c("MarkdownContent", { attrs: { content: _vm.message } })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }